import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import $ from 'jquery';
import jQuery from 'jquery';
(function ($) {
    $.simpleTicker = function (elem, options) {
        var defaults = {
            speed: 2000,
            delay: 6000,
            easing: 'swing',
            effectType: 'slide'
        };

        var param = {
            'ul': '',
            'li': '',
            'initList': '',
            'ulWidth': '',
            'liHeight': '',
            'tickerHook': 'tickerHook',
            'effect': {}
        };

        var plugin = this;
        plugin.settings = {};

        var $element = $(elem),
            element = elem;

        plugin.init = function () {
            plugin.settings = $.extend({}, defaults, options);
            param.ul = element.children('ul');
            param.li = element.find('li');
            param.initList = element.find('li:first');
            param.ulWidth = param.ul.width();
            param.liHeight = param.li.height();

            element.css({ height: (param.liHeight) });
            param.li.css({ top: '0', left: '0', position: 'absolute' });

            //dispatch
            switch (plugin.settings.effectType) {
                case 'fade':
                    plugin.effect.fade();
                    break;
                case 'roll':
                    plugin.effect.roll();
                    break;
                case 'slide':
                    plugin.effect.slide();
                    break;
            }
            plugin.effect.exec();
        };

        plugin.effect = {};

        plugin.effect.exec = function () {
            param.initList.css(param.effect.init.css)
                .animate(param.effect.init.animate, plugin.settings.speed, plugin.settings.easing)
                .addClass(param.tickerHook);
            if (element.find(param.li).length > 1) {
                setInterval(function () {
                    element.find('.' + param.tickerHook)
                        .animate(param.effect.start.animate, plugin.settings.speed, plugin.settings.easing)
                        .next()
                        .css(param.effect.next.css)
                        .animate(param.effect.next.animate, plugin.settings.speed, plugin.settings.easing)
                        .addClass(param.tickerHook)
                        .end()
                        .appendTo(param.ul)
                        .css(param.effect.end.css)
                        .removeClass(param.tickerHook);
                }, plugin.settings.delay);
            }
        };

        plugin.effect.fade = function () {
            param.effect = {
                'init': {
                    'css': { display: 'block', opacity: '0' },
                    'animate': { opacity: '1', zIndex: '98' }
                },
                'start': {
                    'animate': { opacity: '0' }
                },
                'next': {
                    'css': { display: 'block', opacity: '0', zIndex: '99' },
                    'animate': { opacity: '1' }
                },
                'end': {
                    'css': { display: 'none', zIndex: '98' }
                }
            };
        };

        plugin.effect.roll = function () {
            param.effect = {
                'init': {
                    'css': { top: '3em', display: 'block', opacity: '0' },
                    'animate': { top: '0', opacity: '1', zIndex: '98' }
                },
                'start': {
                    'animate': { top: '-1em', opacity: '0' }
                },
                'next': {
                    'css': { top: '3em', display: 'block', opacity: '0', zIndex: '99' },
                    'animate': { top: '0', opacity: '1' }
                },
                'end': {
                    'css': { zIndex: '98' }
                }
            };
        };


        plugin.effect.slide = function () {
            param.effect = {
                'init': {
                    'css': { left: (200), display: 'block', opacity: '0' },
                    'animate': { left: '0', opacity: '1', zIndex: '98' }
                },
                'start': {
                    'animate': { left: (-(200)), opacity: '0' }
                },
                'next': {
                    'css': { left: (param.ulWidth), display: 'block', opacity: '0', zIndex: '99' },
                    'animate': { left: '0', opacity: '1' }
                },
                'end': {
                    'css': { zIndex: '98' }
                }
            };
        };

        plugin.init();
    };

    $.fn.simpleTicker = function (options) {
        return this.each(function () {
            if (undefined == $(this).data('simpleTicker')) {
                var plugin = new $.simpleTiecker(this, options);
                $(this).data('simpleTicker', plugin);
            }
        });
    };
})(jQuery);
const NewsEventsSection = () => {
    useEffect(() => {
        $(function () {
            $.simpleTicker($("#ticker-fade"), { 'effectType': 'fade' });
            $.simpleTicker($("#ticker-roll"), { 'effectType': 'roll' });
            $.simpleTicker($("#ticker-slide"), { 'effectType': 'slide' });
            $.simpleTicker($("#ticker-one-item"), { 'effectType': 'fade' });
        });
    }, []);

    return (
        <section className="newsEventsSection padd-30">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-6 col-sm-12 col-xs-12 leftEventsArea">
                        <div className="commanHead">
                            <h2> News & Events </h2>
                        </div>
                        <div id="ticker-roll" className="ticker">
                            <ul>
                                <li>
                                    <h2><span> 1 Jan 2020 </span></h2>
                                    <h3> Foundation Day Celebration at Adber Infra India Pvt. Ltd. </h3>
                                    <p>
                                        <img className="media-object" src="../assets/images/news-events-02.jpg" alt="Foundation Day" title="Foundation Day" />
                                        <span> Every year we celebrated Foundation Day ..</span>
                                    </p>
                                </li>
                                <li>
                                    <h2><span> 23 May 2018 </span></h2>
                                    <h3> Employee Health Checkup </h3>
                                    <p>
                                        <img className="media-object" src="../assets/images/news-events-01.jpg" alt="Employee Health Checkup" title="Employee Health Checkup" />
                                        <span> Our employee health checkup programme helps to identify.. </span>
                                    </p>
                                </li>
                            </ul>
                        </div>
                        <div className="col-md-12 col-sm-12 col-xs-12 text-center">
                            <Link href="/news-and-events" className="blinkBtn blink" data-form="order-form" data-btn-type="open-form"> View All News and Events </Link>
                        </div>
                    </div>
                    <div className="col-md-6 col-sm-12 col-xs-12 outerArea">
                        <img src="../assets/images/featureBg.jpg" alt=" " title=" " />
                        <div className="cam-frame-left"></div>
                        <div className="captionWrapper">
                            <h5> Top player in the category Ready Mix Concrete Manufacturing and Services in the Pune. </h5>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default NewsEventsSection;
